"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var keylog_service_1 = __importDefault(require("@services/keylog-service"));
(function (module) {
    'use strict';
    function ExportButtonController($scope, modal) {
        var $ctrl = this;
        var keylog = new keylog_service_1.default();
        // Override Ctrl+P/Cmd+P
        keylog.registerAction([keylog.CTRL, keylog.P], function () {
            $ctrl.openExportModal();
        });
        angular.extend($ctrl, {
            openExportModal: function () {
                modal.show();
            }
        });
    }
    ExportButtonController.$inject = [
        '$scope',
        'prEeExportModal'
    ];
    module.controller('prEeExportButtonController', ExportButtonController);
})(angular.module('qualtrics.pr'));
